import axios from "axios"
import queryString from "query-string"
import * as appDataService from "@/AppDataService"
import * as utils from "@/Shared/utils"
import lodash from "lodash"
import {
  API_PROVIDER_GROUP,
  API_PROVIDER_CONFIGURATION,
  API_TEMPLATE,
  API_IS_ACCOUNT_EXISTS,
  API_IS_DROPLOCATION_INUSE
} from "./urls"

/**
 * retrieveProviderGroups - Retrieve provider groups
 * @param {object} queryObjectInput
 * @returns {Promise}
 */
export function retrieveProviderGroups(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      if (lodash.isUndefined(queryObject.sort)) {
        queryObject["sort"] = "title"
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let providerGroupsURL = utils.getServerUrl() + API_PROVIDER_GROUP
      providerGroupsURL += "?" + queryString.stringify(queryObject)
      let providerGroupsResponse = {}
      return axios
        .get(providerGroupsURL)
        .then((response) => {
          providerGroupsResponse = response
          return providerGroupsResponse
        })
        .catch((error) => {
          providerGroupsResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * addProviderGroup - Add provider group
 * @param {object} providerGroup
 * @returns {Promise}
 */
export function addProviderGroup(providerGroup, accountId, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["account"] = accountId
      queryObject["serviceURL"] = serviceURL
      let providerGroupsURL = utils.getServerUrl() + API_PROVIDER_GROUP
      providerGroupsURL += "?" + queryString.stringify(queryObject)
      let providerGroupResponse = {}
      return axios
        .post(providerGroupsURL, providerGroup)
        .then((response) => {
          providerGroupResponse = response
          return providerGroupResponse
        })
        .catch((error) => {
          providerGroupResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * updateProviderGroup - Update provider group Add Provider Group
 * @param {object} providerGroup
 * @returns {Promise}
 */
export function updateProviderGroup(providerGroup, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let providerGroupsURL = utils.getServerUrl() + API_PROVIDER_GROUP
      providerGroupsURL += "?" + queryString.stringify(queryObject)
      let providerGroupResponse = {}
      return axios
        .put(providerGroupsURL, providerGroup)
        .then((response) => {
          providerGroupResponse = response
          return providerGroupResponse
        })
        .catch((error) => {
          providerGroupResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * deleteProviderGroup - Delete provider group
 * @param {string} providerGroupId
 * @param {string} providerGroupOwnerId
 * @returns {Promise}
 */
export function deleteProviderGroup(
  providerGroupId,
  providerGroupOwnerId,
  accountId,
  serviceURL
) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["providerGroupOwnerId"] = providerGroupOwnerId
      queryObject["providerGroupId"] = providerGroupId
      queryObject["account"] = accountId
      queryObject["serviceURL"] = serviceURL
      let providerGroupsURL = utils.getServerUrl() + API_PROVIDER_GROUP
      providerGroupsURL += "?" + queryString.stringify(queryObject)
      let providerGroupResponse = {}
      return axios
        .delete(providerGroupsURL)
        .then((response) => {
          providerGroupResponse = response
          return providerGroupResponse
        })
        .catch((error) => {
          providerGroupResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * isDropLocationInUse - checks if given drop location is already in use
 * @param {string} dropLocation
 * @returns {Promise}
 */
export function isDropLocationInUse(dropLocation, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["byDropLocation"] = dropLocation
      queryObject["serviceURL"] = serviceURL
      let dropLocationURL = utils.getServerUrl() + API_IS_DROPLOCATION_INUSE
      dropLocationURL += "?" + queryString.stringify(queryObject)
      let dropLocationResponse = {}
      return axios
        .get(dropLocationURL)
        .then((response) => {
          dropLocationResponse = response
          return dropLocationResponse
        })
        .catch((error) => {
          dropLocationResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * isAccountExits - Check if given account exits
 * @param {string} accountTitle
 * @returns {Promise}
 */
export function isAccountExits(accountTitle) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["byTitle"] = accountTitle
      queryObject["token"] = token
      let accountExitsURL = utils.getServerUrl() + API_IS_ACCOUNT_EXISTS
      accountExitsURL += "?" + queryString.stringify(queryObject)
      let accountExistsResponse = {}
      return axios
        .get(accountExitsURL)
        .then((response) => {
          accountExistsResponse = response
          return accountExistsResponse
        })
        .catch((error) => {
          accountExistsResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * retrieveTemplates - Retrieve templates
 * @param {*} queryObjectInput
 */
export function retrieveTemplates(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let templateURL = utils.getServerUrl() + API_TEMPLATE
      templateURL += "?" + queryString.stringify(queryObject)
      let templatesResponse = {}
      return axios
        .get(templateURL)
        .then((response) => {
          templatesResponse = response
          return templatesResponse
        })
        .catch((error) => {
          templatesResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * isTemplateTitleExists - checks if template titile is already used
 * @param {object} queryObjectInput
 * @returns {Promise}
 */
export function isTemplateTitleExists(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let templateURL = utils.getServerUrl() + API_TEMPLATE
      templateURL += "?" + queryString.stringify(queryObject)
      let templateTitleResponse = {}
      return axios
        .get(templateURL)
        .then((response) => {
          templateTitleResponse = response
          return templateTitleResponse
        })
        .catch((error) => {
          templateTitleResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * createTemplate - add template
 * @param {object} template
 * @returns {Promise}
 */
export function createTemplate(template, queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let templateURL = utils.getServerUrl() + API_TEMPLATE
      templateURL += "?" + queryString.stringify(queryObject)
      let templateCreateResponse = {}
      return axios
        .post(templateURL, template)
        .then((response) => {
          templateCreateResponse = response
          return templateCreateResponse
        })
        .catch((error) => {
          templateCreateResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * updateTemplate - Update template information
 * @param {object} providerGroup
 * @returns {Promise}
 */
export function updateTemplate(template, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let templateURL = utils.getServerUrl() + API_TEMPLATE
      templateURL += "?" + queryString.stringify(queryObject)
      let templateUpdateResponse = {}
      return axios
        .put(templateURL, template)
        .then((response) => {
          templateUpdateResponse = response
          return templateUpdateResponse
        })
        .catch((error) => {
          templateUpdateResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * deleteTemplate - Delete provider group
 * @param {string} templateId
 * @returns {Promise}
 */
export function deleteTemplate(templateId, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["templateId"] = templateId
      queryObject["serviceURL"] = serviceURL
      let templateURL = utils.getServerUrl() + API_TEMPLATE
      templateURL += "?" + queryString.stringify(queryObject)
      let templateResponse = {}
      return axios
        .delete(templateURL)
        .then((response) => {
          templateResponse = response
          return templateResponse
        })
        .catch((error) => {
          templateResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * Retrieve provider groups
 * @param {*} queryObjectInput
 */
export function retrieveProviders(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["sort"] = "title"
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let providersURL = utils.getServerUrl() + API_PROVIDER_CONFIGURATION
      providersURL += "?" + queryString.stringify(queryObject)
      let providersResponse = {}
      return axios
        .get(providersURL)
        .then((response) => {
          providersResponse = response
          return providersResponse
        })
        .catch((error) => {
          providersResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * addProvider - Add provider group
 * @param {object} provider
 * @returns {Promise}
 */
export function addProvider(provider, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let providerConfigURL = utils.getServerUrl() + API_PROVIDER_CONFIGURATION
      providerConfigURL += "?" + queryString.stringify(queryObject)
      let providerConfigResponse = {}
      return axios
        .post(providerConfigURL, provider)
        .then((response) => {
          providerConfigResponse = response
          return providerConfigResponse
        })
        .catch((error) => {
          providerConfigResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * updateProvider - Update provider group Add Provider Group
 * @param {object} provider
 * @returns {Promise}
 */
export function updateProvider(provider, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let providerConfigURL = utils.getServerUrl() + API_PROVIDER_GROUP
      providerConfigURL += "?" + queryString.stringify(queryObject)
      let providerConfigResponse = {}
      return axios
        .put(providerConfigURL, provider)
        .then((response) => {
          providerConfigResponse = response
          return providerConfigResponse
        })
        .catch((error) => {
          providerConfigResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * deleteProvider - Delete provider group
 * @param {string} providerGroupId
 * @param {string} providerGroupOwnerId
 * @returns {Promise}
 */
export function deleteProvider(providerId, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then((userInfo) => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["providerId"] = providerId
      queryObject["serviceURL"] = serviceURL
      let providerConfigURL = utils.getServerUrl() + API_PROVIDER_GROUP
      providerConfigURL += "?" + queryString.stringify(queryObject)
      let providerConfigResponse = {}
      return axios
        .delete(providerConfigURL)
        .then((response) => {
          providerConfigResponse = response
          return providerConfigResponse
        })
        .catch((error) => {
          providerConfigResponse = {}
          return Promise.reject(error)
        })
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/Providers/ProvidersDataService.js